import { render, staticRenderFns } from "./IngresoDocumentosS1.vue?vue&type=template&id=bc099516&"
import script from "./IngresoDocumentosS1.vue?vue&type=script&lang=js&"
export * from "./IngresoDocumentosS1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports